module.exports = __webpack_public_path__ + "img/user-robot.162ed00b.svg";